export const environment = {
    production: false,    
    beaconUrl: `https://beaconqa.biworldwide.com`,
    domain: `https://qa.outlook.recognitionnow.com`
};